export default __webpack_public_path__ + "static/psgCard6-5c9d6d50d86afe6292fc9351fde8eef8.webp";